module.exports = __webpack_public_path__ + "static/media/RunNUS_Poster_Portrait.628f77a8.png";